import {
  type AcknowledgementHistory,
  type Acknowledgement,
} from '@reliance/types/models/Acknowledgement';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService, type QueryParams } from '../types/ApiService';

export const acknowledgement = (centralApi: ApiService) => ({
  index: (
    params: QueryParams = {},
  ): Promise<PaginatedResponse<Acknowledgement>> => {
    return centralApi.get<PaginatedResponse<Acknowledgement>>(
      '/acknowledgement',
      {
        params,
      },
    );
  },
  history: {
    index: (
      params: QueryParams = {},
    ): Promise<PaginatedResponse<AcknowledgementHistory>> => {
      return centralApi.get<PaginatedResponse<AcknowledgementHistory>>(
        '/acknowledgement/history',
        {
          params,
        },
      );
    },
  },
});
